<template>
    <section>
        <div class="intro_section2" style="display: flex; position: relative; ">
            <div class="con_wrap" style="display: flex; flex-direction: column; padding-top: 115px">
                <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; margin-bottom: 195px;">
                    <p data-aos="fade-up"
                        data-aos-delay="0"
                        data-aos-once="true"
                        data-aos-duration="600"
                        data-aos-easing="ease-in-out" style="font-size: 25px; font-weight: 700; color: white; text-align: center; color: #000000; margin-bottom: 22px;">
                        About
                    </p>
                    <p data-aos="fade-up"
                        data-aos-delay="300"
                        data-aos-once="true"
                        data-aos-duration="600"
                        data-aos-easing="ease-in-out" style="font-size: 50px; font-weight: 700; color: white; text-align: center; color: #000000; margin-bottom: 41px;">
                        우리는 인공지능 입시 코디네이터 서비스를<br>
                        제공하고 있습니다.
                    </p>
                    <p data-aos="fade-up"
                        data-aos-delay="400"
                        data-aos-once="true"
                        data-aos-duration="600"
                        data-aos-easing="ease-in-out" style="font-size: 22px; font-weight: 400; text-align: center; color: #5A5A5A; line-height: 1.5;">
                        언제 어디서나 누구든지 부담없이 사용할 수 있는 온라인 학업 플랫폼입니다.<br>
                        공부가 필요한 순간이라면, 누구나 언제든지 필드유와 함께할 수 있도록<br>
                        늘 고민하고 구상합니다. 풀다는 2019년 첫 선을 보인후, 빠르게 성장하고 있습니다.
                        <!-- 필드유 팀원들은 이렇게 생각하고 임하고 있습니다.
                        우리가 지향하는 목표를 계속 잊지 않고 크고 작은 목표들을 달성해나갈 때마다 어느새 우리는 우리가
                        목표로 세웠던 방향에 도달할 수 있을 것입니다. 우리는 교육의 혁신을 이루어내고자 함께 모였으며,
                        앞으로도 우리는 계속해서 고민을 하고, 답을 찾을 것입니다. -->
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { ChevronDownIcon } from 'vue-feather-icons'
export default {
    components: {
        ChevronDownIcon,
    },
    data() {
        return {

        }
    },
    
}
</script>
<style>
    .intro_section2 {
        width: 100vw;
        background: white;
        object-fit: inherit;
    }
</style>